<!--
 * @Author: Tahiti
 * @Date: 2025-10-20 16:27:22
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 13:41:44
 * @Description: My Creations Page
 * @FilePath: /weryai-web/pages/my-creations.vue
-->
<template>
    <div class="my-creations-page">
        <h1 class="sr-only">{{ t('myCreations.pageTitle') }}</h1>
        <!-- user info -->
        <ClientOnly>
            <div class="flex w-full mb-5 mt-5 items-center justify-end md:hidden">
                <el-dropdown class="flex items-center" :show-arrow="false" popper-style="popper"
                    popper-class="generate-popper" trigger="click">
                    <button class="flex items-center justify-center">
                        <img class="w-[35px] h-[35px]"
                            src="https://static.weryai.com/growth/image/weryai_fed2a359d4c04480f76b1ef76d280a4f.webp"
                            alt="setting" />
                    </button>
                    <template #dropdown>
                        <el-dropdown-menu class="my-setting">
                            <el-dropdown-item v-for="item in chooseTypeEnums" :key="item.name"
                                @click="handleChooseType(item?.type)">
                                <span :class="item.icon" class="w-4 h-4"></span>

                                <span class="flex flex-col items-start">
                                    {{ item.name }}
                                </span>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="isLoggedIn" @click="handleChooseType('logout')">
                                <div
                                    class="w-full whitespace-nowrap text-left text-sm text-red-500 hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                        </path>
                                    </svg>
                                    <span class="flex flex-col items-start">
                                        {{
                                            t('menus.logout') +
                                            `(v${runtimeConfig.public.appVersion})`
                                        }}
                                    </span>
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </ClientOnly>
        <div v-if="user_info" class="md:pt-8 mb-[30px] flex items-center justify-between">
            <ClientOnly>
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-4">
                        <div class="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden border-2 border-white/20"
                            @click="emitter.emit('open-user-profile-modal')">
                            <img :src="user_info.avatar" class="w-[98%] h-[98%] object-cover" alt="user-avatar" />
                        </div>
                        <div>
                            <h2 class="nick-name max-w-[200px] md:max-w-[400px] truncate font-bold">
                                {{ user_info.nick_name }}
                            </h2>
                        </div>
                    </div>

                    <el-dropdown class="flex items-center" :show-arrow="false" popper-style="popper"
                        popper-class="generate-popper" trigger="click">
                        <button class="hidden md:flex items-center justify-center">
                            <img class="w-[35px] h-[35px]"
                                src="https://static.weryai.com/growth/image/weryai_fed2a359d4c04480f76b1ef76d280a4f.webp"
                                alt="setting" />
                        </button>
                        <template #dropdown>
                            <el-dropdown-menu class="my-setting">
                                <el-dropdown-item v-for="item in chooseTypeEnums" :key="item.name"
                                    @click="handleChooseType(item?.type)">
                                    <span :class="item.icon" class="w-4 h-4"></span>

                                    <span class="flex flex-col items-start">
                                        {{ item.name }}
                                    </span>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="isLoggedIn" @click="handleChooseType('logout')">
                                    <div
                                        class="w-full whitespace-nowrap text-left text-sm text-red-500 hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                            </path>
                                        </svg>
                                        <span class="flex flex-col items-start">
                                            {{
                                                t('menus.logout') +
                                                `(v${runtimeConfig.public.appVersion})`
                                            }}
                                        </span>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
                <template #fallback>
                    <div class="flex items-center gap-4">
                        <div class="w-16 h-16 rounded-full bg-gray-400 animate-pulse"></div>
                    </div>
                </template>
            </ClientOnly>
        </div>
        <div v-else-if="LOGIN_ENTRY_ENABLED" class="md:pt-8 mb-[30px] flex gap-[18px] items-center justify-start">

            <div class="flex items-center justify-center rounded-full overflow-hidden border-2 border-white/20">
                <img src="https://static.weryai.com/growth/image/weryai_1fde0dc7c3ca62c6cb6c69df17d49116.webp"
                    class="w-[70px] h-[70px] object-cover" alt="user-empty" @click="showLoginModal()" />
            </div>
            <div class="flex flex-col items-start justify-center">
                <h2 class="text-white text-base  max-w-[200px] md:max-w-[400px] truncate font-bold"
                    @click="showLoginModal()">
                    {{ t('order_modal.right_now_login') }}
                </h2>
                <h3 class="text-sm text-[#71717A] max-w-[200px] truncate">{{ t('order_modal.login_to_use_more_features')
                }}</h3>
            </div>
        </div>
        <div class="mb-[10px] md:hidden block">
            <div class="credits-card w-full rounded-[14px] px-[15px] py-[10px] relative group cursor-pointer">
                <div class="relative z-10 flex justify-between items-center">
                    <div class="text-lg font-bold text-white mb-1 flex items-center gap-2">
                        <img src='https://static.weryai.com/growth/image/weryai_70e24907b5e310365418a3ec7e4d9bb2.webp'
                            alt="credits" class="w-[35px] h-auto" />
                        <span class="flex gap-2 flex-col items-start justify-center">
                            <span class="text-[#71717A] leading-none text-[10px] font-semibold flex items-center gap-1">
                                <span> {{ t('myCreations.credits') }} </span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"
                                    fill="none">
                                    <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="#71717A" stroke-width="0.833333"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span class="text-white text-lg leading-none font-bold">
                                {{ formattedCredits }}
                            </span>
                        </span>
                    </div>

                    <button
                        class="bg-white text-black text-xs font-bold px-4 py-2 rounded-full hover:bg-white/80 transition-all duration-300"
                        @click="emitOpenGoodsModal()">
                        {{ t('myCreations.recharge') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="mb-[30px]">
            <div class="vip-card w-full px-[15px] py-[10px] relative group cursor-pointer">
                <div v-if="!isVip" class="relative z-10 flex justify-between items-center">
                    <div>
                        <h3 class="text-lg font-bold text-white mb-1 flex items-center gap-2">
                            <img src="https://static.weryai.com/growth/image/weryai_3d8a8d7fe5f0f80295d9ce8a945e70de.webp"
                                alt="vip" class="w-[18px] h-auto" />

                            <span class="pro-text"> 微鲤AI PRO </span>
                        </h3>
                        <p class="text-xs text-[#9CA3AF]">
                            {{ t('myCreations.lock_tips') }}
                        </p>
                    </div>
                    <button
                        class="bg-[#5CFD81] whitespace-nowrap text-black text-xs font-bold px-4 py-2 rounded-full hover:bg-white/80 transition-all duration-300"
                        @click="emitOpenGoodsModal()">
                        {{ t('myCreations.start_vip') }}
                    </button>
                </div>
                <div v-else>
                    <div>
                        <h3 class="text-lg font-bold text-white mb-1 flex items-center gap-2">
                            <img v-if="
                                sub_info?.subscription_type === 'PLAN_ENTRY'
                            " src="~/assets/images/common/vip-entry.png" alt="vip" class="w-[35px] h-[35px]" />
                            <img v-else-if="
                                sub_info?.subscription_type === 'PLAN_BASIC'
                            " src="~/assets/images/common/vip-basic.png" alt="vip" class="w-[35px] h-[35px]" />
                            <img v-else-if="
                                sub_info?.subscription_type === 'PLAN_PRO'
                            " src="~/assets/images/common/vip-pro.png" alt="vip" class="w-[35px] h-[35px]" />

                            <span class="pay-money">
                                {{ sub_info?.subscription_name }}
                            </span>
                        </h3>
                        <p class="text-xs text-[#9CA3AF]">
                            {{
                                t('myCreations.next_billing_date', {
                                    time: sub_info?.next_billing_date,
                                })
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex items-center justify-between mb-4">
            <h3 class="text-white font-bold text-lg">
                {{ t('myCreations.my_creations') }}
            </h3>

            <img class="w-8 h-8 cursor-pointer block md:hidden"
                src="https://static.weryai.com/growth/image/weryai_cac6c1e2e1042cfe0436ae60ea69ba67.webp" alt="filter"
                @click="handleFilter" />
            <div
                class="hidden md:flex text-sm px-5 gap-3 py-[10px] text-white items-center justify-center h-[41px] rounded-[10px] bg-[#26262a]">
                <el-dropdown class="flex items-center" :aria-label="t('myCreations.filterByTime')">
                    <span class="flex items-center text-sm gap-1">
                        {{
                            timeEnums.find(item => item.value === query.time)
                                ?.label
                        }}
                        <span class="i-down-icon w-3 h-3" aria-hidden="true"></span>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item v-for="item in timeEnums" :key="item.value"
                                @click="handleChangeTime(item.value)" :class="{
                                    '!text-text-active':
                                        query.time === item.value,
                                }">{{ item.label }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <div class="w-[1px] h-[13px] bg-[#4C4F5B]"></div>

                <el-dropdown class="flex items-center" :aria-label="t('myCreations.filterByType')">
                    <span class="flex items-center text-sm gap-1">
                        {{
                            generate_type_list.find(
                                item => item.value === query.category
                            )?.label
                        }}
                        <span class="i-down-icon w-3 h-3" aria-hidden="true"></span>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item v-for="item in generate_type_list" :key="item.value"
                                @click="handleChangeGenerateType(item.value)" :class="{
                                    '!text-text-active':
                                        query.category === item.value,
                                }">{{ item.label }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>

        <div class="content-container">
            <!-- Loading State -->
            <template v-if="loading">
                <div class="flex flex-col justify-center items-center min-h-[400px]">
                    <l-dot-spinner v-if="isClient" size="60" speed="0.9"
                        color="var(--el-menu-active-color)"></l-dot-spinner>
                    <div class="text-white text-lg mt-4">
                        {{ t('myCreations.loading') }}
                    </div>
                </div>
            </template>

            <!-- Content Grid and Pagination -->
            <template v-else-if="hasContent">
                <div class="flex gap-3">
                    <div v-for="(column, colIndex) in columnList" :key="colIndex"
                        class="waterfall-column flex-1 flex flex-col gap-3">
                        <div v-for="item in column" :key="item.id"
                            class="bg-[#26262a] rounded-lg overflow-hidden hover:bg-[#3c3f4b] transition-colors duration-200 group cursor-pointer"
                            @click="openPreview(item)">
                            <!-- Thumbnail -->
                            <div class="relative min-h-[100px] bg-[#26262a] flex items-center justify-center">
                                <div style="display: none"
                                    class="w-full aspect-square bg-[#060608] flex items-center flex-col gap-2 justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"
                                        fill="none">
                                        <path
                                            d="M15.9375 12.5003H42.6737C42.495 12.8003 42.3237 13.0978 42.1637 13.3903C41.1087 15.3178 40.5 16.9828 40.5 18.5778C40.5 23.2815 44.0625 26.5778 48.625 26.5778L48.7513 26.5765L48.75 45.3215C48.7493 45.9365 48.6276 46.5452 48.3917 47.1131C48.1557 47.6809 47.8103 48.1968 47.375 48.6311C46.9397 49.0655 46.4232 49.4098 45.8548 49.6445C45.2864 49.8792 44.6774 49.9997 44.0625 49.999H15.9375C15.3226 49.9997 14.7136 49.8792 14.1452 49.6445C13.5768 49.4098 13.0603 49.0655 12.625 48.6311C12.1897 48.1968 11.8443 47.6809 11.6083 47.1131C11.3724 46.5452 11.2507 45.9365 11.25 45.3215V17.1778C11.2507 16.5629 11.3724 15.9541 11.6083 15.3863C11.8443 14.8184 12.1897 14.3026 12.625 13.8682C13.0603 13.4339 13.5768 13.0895 14.1452 12.8548C14.7136 12.6201 15.3226 12.4996 15.9375 12.5003ZM30.0075 33.584C25.9362 33.584 22.3475 35.7353 20.2162 39.0278C20.0414 39.2959 19.9444 39.6073 19.936 39.9273C19.9276 40.2473 20.0082 40.5634 20.1687 40.8403C20.3237 41.1103 20.5513 41.3428 20.8363 41.5028C21.0988 41.6515 21.41 41.739 21.7575 41.739C22.3088 41.7465 22.8325 41.4753 23.145 41.014C23.8849 39.8629 24.8998 38.9141 26.0981 38.2533C27.2964 37.5925 28.6404 37.2405 30.0088 37.229C32.8663 37.229 35.3875 38.7028 36.8975 41.0065C37.21 41.469 37.725 41.7478 38.36 41.7428C38.6862 41.7428 38.9837 41.6503 39.235 41.4953C39.5003 41.3263 39.7167 41.0907 39.8623 40.8119C40.008 40.533 40.0779 40.2209 40.065 39.9065C40.0509 39.5935 39.9529 39.29 39.7812 39.0278C37.65 35.7428 34.065 33.584 30.0063 33.584H30.0075ZM36.65 25.2803C35.46 25.2865 34.3625 25.9303 33.7725 26.9715C33.4822 27.4836 33.331 28.0626 33.3338 28.6512C33.3367 29.2398 33.4935 29.8174 33.7887 30.3265C34.0822 30.834 34.5044 31.255 35.0128 31.5469C35.5211 31.8389 36.0975 31.9914 36.6838 31.989C37.1229 31.9854 37.557 31.8954 37.9613 31.724C38.3656 31.5527 38.7322 31.3033 39.0401 30.9903C39.3481 30.6772 39.5913 30.3066 39.756 29.8995C39.9207 29.4924 40.0036 29.0569 40 28.6178C39.9992 28.1787 39.9119 27.744 39.7431 27.3387C39.5743 26.9333 39.3273 26.5652 39.0162 26.2552C38.7051 25.9453 38.3361 25.6997 37.9301 25.5324C37.5241 25.3651 37.0891 25.2795 36.65 25.2803ZM23.32 25.2803C22.8809 25.2834 22.4467 25.373 22.0422 25.5439C21.6377 25.7148 21.2708 25.9637 20.9625 26.2764C20.6543 26.5891 20.4106 26.9595 20.2454 27.3664C20.0803 27.7733 19.9969 28.2087 20 28.6478C20.0003 29.0869 20.0871 29.5216 20.2555 29.9272C20.4238 30.3328 20.6704 30.7012 20.9811 31.0115C21.2919 31.3217 21.6607 31.5677 22.0665 31.7355C22.4723 31.9032 22.9071 31.9894 23.3462 31.989C23.9325 31.986 24.5075 31.8282 25.0132 31.5317C25.5189 31.2351 25.9373 30.8104 26.2262 30.3003C26.5169 29.7885 26.6686 29.2095 26.6662 28.621C26.6638 28.0324 26.5074 27.4547 26.2125 26.9453C25.9196 26.4377 25.4979 26.0165 24.99 25.7241C24.4821 25.4317 23.906 25.2786 23.32 25.2803ZM48.625 9.67529L48.97 10.109C50.0825 11.529 53.5 16.0928 53.5 18.5778C53.5 21.4528 51.4513 23.2128 48.875 23.3203L48.625 23.3253C46.0162 23.3253 43.8875 21.6553 43.7562 18.8515L43.75 18.5765C43.75 18.5765 43.7562 18.3515 43.77 18.2328L43.8188 17.914L43.855 17.739C43.895 17.5615 43.9462 17.379 44.0062 17.1915L44.1375 16.8165L44.2863 16.4428L44.3862 16.2078L44.5438 15.8665L44.7625 15.4253L44.7625 15.4253L45.0325 14.9165L45.0675 14.854C45.3795 14.2988 45.7088 13.7536 46.055 13.219L46.5088 12.534C47.6112 10.909 48.625 9.67529 48.625 9.67529Z"
                                            fill="#6C707E" />
                                    </svg>
                                    <span class="text-[#6C707D] text-xs text-center">{{
                                        t('batchTools.generateFailed')
                                        }}</span>
                                </div>
                                <template v-if="item.result_type === 'IMAGE'">
                                    <!-- origin -->
                                    <UiImageLoadLoading :src="getCreationImageUrl(item)" :alt="item.type_name ||
                                        t('myCreations.imageCreation')
                                        " class="inset-0 w-full h-full object-contain" />
                                </template>

                                <UiImageLoadLoading v-else-if="item.result_type === 'VIDEO'" :src="item?.results?.[0] ||
                                    item?.batch_items?.[0]?.results?.[0]
                                    " :is-video="item?.results?.[0] ||
                                        item?.batch_items?.[0]?.results?.[0]
                                        " :autoplay="false" class="max-w-full max-h-full object-cover" />

                                <!-- 音乐类型 - 黑胶唱片样式 -->
                                <div v-else-if="
                                    item.result_type === 'AUDIO' ||
                                    item?.type ===
                                    'MUSIC_CREATION_GENERATION'
                                " class="w-full h-full music-card-container">
                                    <!-- 背景层：图片 + 高斯模糊 -->
                                    <div class="music-card-bg" :style="{
                                        backgroundImage: `url(${item?.results?.[0] || ''})`,
                                    }"></div>

                                    <!-- 黑胶唱片 -->
                                    <div class="vinyl-record">
                                        <div class="vinyl-outer"></div>
                                        <div class="vinyl-inner">
                                            <img :src="item?.results?.[0] || ''" :alt="item.music?.music_title ||
                                                t(
                                                    'myCreations.musicCreation'
                                                )
                                                " class="vinyl-cover" />
                                        </div>
                                    </div>

                                    <!-- 左上角音乐标签 -->
                                    <div class="music-type-tag">
                                        <img src="~/assets/images/common/music-type.png" alt="音乐类型图标"
                                            class="w-[9px] h-[9px]" />
                                        <span>{{ t('batchTools.AUDIO') }}</span>
                                    </div>
                                </div>

                                <!-- Video Duration Badge -->
                                <div v-if="
                                    item.result_type === 'VIDEO' &&
                                    item.status !== 'FAILED'
                                "
                                    class="absolute bottom-2 left-2 px-2 py-1 rounded text-[12px] text-white bg-[#121212]/70">
                                    {{
                                        formatDuration(
                                            item.duration ||
                                            item.video_duration ||
                                            item.length ||
                                            item.seconds
                                        )
                                    }}
                                </div>
                                <div v-if="
                                    ['SUCCESS', 'PARTIAL_SUCCESS'].includes(
                                        item.status
                                    )
                                "
                                    class="min-w-[1px] px-2 p-1 rounded-[4px] bg-black/30 absolute bottom-1 right-1 flex items-center justify-end gap-2 hover:bg-black/75 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                    <button class="copyLink hover:scale-110 transition-all duration-300"
                                        :aria-label="t('inspiration.copyLink')" @click.stop="copyLink(item)">
                                        <img src="https://static.weryai.com/growth/image/weryai_838863a3d0c4cd98a0c5f45bf05746b2.png"
                                            alt="复制链接图标" class="w-4 h-4" />
                                    </button>
                                    <button class="hover:scale-110 transition-all duration-300"
                                        :aria-label="t('myCreations.download')" @click.stop="downloadItem(item)">
                                        <img src="https://static.weryai.com/growth/image/weryai_ea4ff7c84794caa9280e7161bb8e65de.png"
                                            alt="下载图标" class="w-4 h-4" />
                                    </button>
                                </div>

                                <!-- Overlay Icons -->
                                <div
                                    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                    <button
                                        class="w-[40px] h-[40px] bg-black/30 rounded flex items-center justify-center hover:bg-black/75 transition-colors"
                                        :aria-label="t('myCreations.preview')" @click.stop="openPreview(item)">
                                        <svg class="w-[20px] h-[20px] text-white" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4">
                                            </path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Infinite Scroll Sentinel -->
                <div class="flex justify-center mt-6 mb-6">
                    <div class="text-gray-400 text-sm flex flex-col items-center gap-2">
                        <template v-if="loadingMore">
                            <l-dot-spinner v-if="isClient" size="40" speed="0.9"
                                color="var(--el-menu-active-color)"></l-dot-spinner>
                        </template>
                        <template v-else-if="!hasMore">
                            <span>{{ t('common.noMore') }}</span>
                        </template>
                    </div>
                </div>
                <div ref="sentinelRef" class="h-8"></div>
            </template>

            <!-- Empty State -->
            <template v-else-if="initialized">
                <div class="flex flex-col items-center justify-center min-h-[500px] px-4">
                    <!-- Empty Icon -->
                    <div class="mb-6">
                        <img src="https://static.weryai.com/growth/image/2946ae77d3f24c870124781c4abb8e9f.webp"
                            :alt="t('myCreations.emptyStateIcon')" class="w-[200px] h-auto" width="200" height="200"
                            loading="lazy" />
                    </div>

                    <!-- Empty Text -->
                    <p class="text-white text-lg font-medium mb-2 text-center max-w-md">
                        {{ t('myCreations.emptyTitle') }}
                    </p>

                    <!-- Create Button -->
                    <button type="button"
                        class="mt-6 w-[204px] h-[42px] bg-[#99F768] cursor-pointer text-black rounded-[10px] font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
                        @click="goToCreate">
                        {{ t('myCreations.createNow') }}
                    </button>
                </div>
            </template>

            <!-- Preview Modal -->
            <div v-if="previewItem" class="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                @click="closePreview">
                <div class="bg-gray-900 rounded-lg max-h-[90vh] relative preview-modal-content" @click.stop>
                    <!-- Close Button -->
                    <button
                        class="absolute top-4 right-4 w-8 h-8 bg-black/20 rounded-full flex items-center justify-center hover:bg-black/75 transition-colors z-10"
                        :aria-label="t('common.close')" @click="closePreview">
                        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>

                    <!-- Preview Content -->
                    <div class="relative preview-content">
                        <div v-if="!hasMultipleResults" class="preview-single">
                            <img v-if="previewItem.result_type === 'IMAGE'" :src="previewItem?.results?.[0] ||
                                previewItem?.batch_items?.[0]?.results?.[0]
                                " :alt="previewItem.title"
                                class="max-w-full h-auto max-h-[70vh] object-contain rounded-lg" />
                            <video v-else-if="previewItem.result_type === 'VIDEO'" :src="previewItem?.results?.[0] ||
                                previewItem?.batch_items?.[0]?.results?.[0]
                                " class="max-w-full h-auto max-h-[70vh] object-contain rounded-lg" controls playsinline
                                webkit-playsinline preload="auto" crossorigin="anonymous"></video>

                            <div class="tool-box">
                                <!-- Download Button Overlay -->
                                <button class="download-button" :disabled="downloading" @click.stop="
                                    downloadCurrentItem(
                                        previewItem?.results?.[0] ||
                                        previewItem?.batch_items?.[0]
                                            ?.results?.[0],
                                        previewItem.result_type
                                    )
                                    ">
                                    <svg v-if="!downloading" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z"
                                            fill="white" />
                                    </svg>
                                    <span v-if="!downloading">{{
                                        t('myCreations.download')
                                    }}</span>
                                    <span v-else>{{
                                        t('myCreations.downloading')
                                    }}</span>
                                </button>
                                <button class="pop-copy-link" :aria-label="t('inspiration.copyLink')" @click.stop="
                                    copyLink({
                                        id: previewItem.id,
                                        results: [
                                            previewItem?.results?.[0] ||
                                            previewItem
                                                ?.batch_items?.[0]
                                                ?.results?.[0],
                                        ],
                                    })
                                    ">
                                    <svg width="20" height="20" viewBox="0 0 14 14" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="w-4 h-4">
                                        <path
                                            d="M3.28718 7.00001C2.79481 6.50765 2.51821 5.83986 2.51821 5.14355C2.51821 4.44725 2.79481 3.77946 3.28718 3.2871C3.77954 2.79473 4.44733 2.51813 5.14363 2.51813C5.83994 2.51813 6.50773 2.79473 7.00009 3.2871L7.92759 4.2146C8.03919 4.31016 8.18273 4.3601 8.32954 4.35443C8.47635 4.34876 8.61562 4.2879 8.7195 4.18401C8.82339 4.08012 8.88425 3.94085 8.88992 3.79404C8.8956 3.64723 8.84566 3.50369 8.75009 3.3921L7.82551 2.46168C7.46784 2.10279 7.04122 1.82003 6.57134 1.63043C5.65501 1.26292 4.63226 1.26292 3.71593 1.63043C3.24665 1.82111 2.82033 2.10389 2.46215 2.46207C2.10397 2.82025 1.82119 3.24657 1.63051 3.71585C1.26118 4.63182 1.26118 5.65528 1.63051 6.57126C1.82011 7.04114 2.10287 7.46776 2.46176 7.82543L3.39218 8.75001C3.50332 8.85037 3.64879 8.90413 3.79848 8.90019C3.94818 8.89624 4.09062 8.83487 4.19631 8.7288C4.30201 8.62273 4.36287 8.48007 4.36629 8.33037C4.3697 8.18067 4.31542 8.03538 4.21468 7.9246L3.28718 7.00001ZM12.3697 7.42876C12.1801 6.95889 11.8973 6.53227 11.5384 6.1746L10.608 5.25001C10.5548 5.19155 10.4904 5.1445 10.4185 5.11171C10.3466 5.07893 10.2688 5.06109 10.1898 5.05929C10.1108 5.05749 10.0322 5.07175 9.95889 5.10122C9.88557 5.13069 9.81901 5.17475 9.76323 5.23072C9.70745 5.2867 9.66363 5.35342 9.63442 5.42684C9.60521 5.50027 9.59122 5.57886 9.59331 5.65785C9.59539 5.73684 9.6135 5.81459 9.64654 5.88637C9.67958 5.95815 9.72686 6.02247 9.78551 6.07543L10.713 7.00001C10.9568 7.24381 11.1502 7.53323 11.2821 7.85176C11.4141 8.17029 11.482 8.5117 11.482 8.85647C11.482 9.20125 11.4141 9.54265 11.2821 9.86118C11.1502 10.1797 10.9568 10.4691 10.713 10.7129C10.4692 10.9567 10.1798 11.1501 9.86126 11.2821C9.54273 11.414 9.20133 11.4819 8.85655 11.4819C8.51178 11.4819 8.17037 11.414 7.85184 11.2821C7.53331 11.1501 7.24389 10.9567 7.00009 10.7129L6.07259 9.78543C6.0203 9.72437 5.95595 9.67477 5.88358 9.63976C5.8112 9.60474 5.73238 9.58507 5.65204 9.58196C5.5717 9.57886 5.49159 9.5924 5.41674 9.62172C5.34188 9.65105 5.2739 9.69553 5.21705 9.75238C5.1602 9.80923 5.11571 9.87722 5.08639 9.95208C5.05706 10.0269 5.04352 10.107 5.04663 10.1874C5.04973 10.2677 5.06941 10.3465 5.10442 10.4189C5.13943 10.4913 5.18903 10.5556 5.25009 10.6079L6.17759 11.5383C6.53526 11.8972 6.96189 12.18 7.43176 12.3696C8.34774 12.7389 9.3712 12.7389 10.2872 12.3696C10.7565 12.1789 11.1828 11.8961 11.541 11.538C11.8991 11.1798 12.1819 10.7535 12.3726 10.2842C12.7419 9.3682 12.7419 8.34474 12.3726 7.42876H12.3697Z"
                                            fill="currentColor" />
                                        <path
                                            d="M8.85566 9.43832C8.96801 9.43574 9.07723 9.40076 9.17017 9.33759C9.26312 9.27442 9.33584 9.18574 9.37958 9.08223C9.42333 8.97871 9.43625 8.86476 9.41678 8.75408C9.39731 8.6434 9.34628 8.5407 9.26983 8.45832L5.55691 4.73082C5.50272 4.67663 5.43837 4.63364 5.36756 4.6043C5.29675 4.57497 5.22085 4.55988 5.1442 4.55988C5.06756 4.55988 4.99166 4.57497 4.92085 4.6043C4.85004 4.63364 4.78569 4.67663 4.7315 4.73082C4.6773 4.78502 4.63431 4.84936 4.60498 4.92018C4.57564 4.99099 4.56055 5.06689 4.56055 5.14353C4.56055 5.22018 4.57564 5.29608 4.60498 5.36689C4.63431 5.4377 4.6773 5.50204 4.7315 5.55624L8.459 9.26916C8.56476 9.37414 8.70669 9.43467 8.85566 9.43832Z"
                                            fill="currentColor" />
                                    </svg>
                                    {{ t('inspiration.copyLink') }}
                                </button>
                            </div>
                        </div>

                        <div v-else class="preview-swiper">
                            <Swiper ref="swiperRef" :modules="modules" :slides-per-view="1" :space-between="20"
                                :loop="true" :navigation="true" class="preview-swiper-container" @swiper="onSwiper"
                                @slide-change="onSlideChange">
                                <SwiperSlide v-for="(item, index) in (previewItem
                                    ?.result_list?.length >
                                    (previewItem?.results?.length || 0)
                                    ? previewItem.result_list
                                    : previewItem.results) || []" :key="index"
                                    class="flex items-center justify-center">
                                    <div class="relative flex items-center justify-center">
                                        <img v-if="
                                            previewItem.result_type ===
                                            'IMAGE'
                                        " :src="item" :alt="`${previewItem.title} - ${Number(index) + 1}`"
                                            class="max-w-full h-auto max-h-[70vh] object-contain rounded-lg" />
                                        <video v-else-if="
                                            previewItem.result_type ===
                                            'VIDEO'
                                        " :src="item" class="max-w-full h-auto max-h-[70vh] object-contain rounded-lg"
                                            controls playsinline webkit-playsinline preload="auto"
                                            crossorigin="anonymous"></video>
                                        <div class="tool-box">
                                            <!-- Download Button Overlay for each slide -->
                                            <button class="download-button" :disabled="downloading" @click.stop="
                                                downloadCurrentItem(
                                                    item,
                                                    previewItem.result_type
                                                )
                                                ">
                                                <svg v-if="!downloading" xmlns="http://www.w3.org/2000/svg" width="24"
                                                    height="24" viewBox="0 0 24 24" fill="none">
                                                    <path
                                                        d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z"
                                                        fill="white" />
                                                </svg>
                                                <span v-if="!downloading">{{
                                                    t('myCreations.download')
                                                }}</span>
                                                <span v-else>{{
                                                    t('myCreations.downloading')
                                                }}</span>
                                            </button>
                                            <button class="pop-copy-link" :aria-label="t('inspiration.copyLink')
                                                " @click.stop="
                                                    copyLink({
                                                        id: previewItem.id,
                                                        results: [item],
                                                    })
                                                    ">
                                                <svg width="20" height="20" viewBox="0 0 14 14" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                                    class="w-4 h-4">
                                                    <path
                                                        d="M3.28718 7.00001C2.79481 6.50765 2.51821 5.83986 2.51821 5.14355C2.51821 4.44725 2.79481 3.77946 3.28718 3.2871C3.77954 2.79473 4.44733 2.51813 5.14363 2.51813C5.83994 2.51813 6.50773 2.79473 7.00009 3.2871L7.92759 4.2146C8.03919 4.31016 8.18273 4.3601 8.32954 4.35443C8.47635 4.34876 8.61562 4.2879 8.7195 4.18401C8.82339 4.08012 8.88425 3.94085 8.88992 3.79404C8.8956 3.64723 8.84566 3.50369 8.75009 3.3921L7.82551 2.46168C7.46784 2.10279 7.04122 1.82003 6.57134 1.63043C5.65501 1.26292 4.63226 1.26292 3.71593 1.63043C3.24665 1.82111 2.82033 2.10389 2.46215 2.46207C2.10397 2.82025 1.82119 3.24657 1.63051 3.71585C1.26118 4.63182 1.26118 5.65528 1.63051 6.57126C1.82011 7.04114 2.10287 7.46776 2.46176 7.82543L3.39218 8.75001C3.50332 8.85037 3.64879 8.90413 3.79848 8.90019C3.94818 8.89624 4.09062 8.83487 4.19631 8.7288C4.30201 8.62273 4.36287 8.48007 4.36629 8.33037C4.3697 8.18067 4.31542 8.03538 4.21468 7.9246L3.28718 7.00001ZM12.3697 7.42876C12.1801 6.95889 11.8973 6.53227 11.5384 6.1746L10.608 5.25001C10.5548 5.19155 10.4904 5.1445 10.4185 5.11171C10.3466 5.07893 10.2688 5.06109 10.1898 5.05929C10.1108 5.05749 10.0322 5.07175 9.95889 5.10122C9.88557 5.13069 9.81901 5.17475 9.76323 5.23072C9.70745 5.2867 9.66363 5.35342 9.63442 5.42684C9.60521 5.50027 9.59122 5.57886 9.59331 5.65785C9.59539 5.73684 9.6135 5.81459 9.64654 5.88637C9.67958 5.95815 9.72686 6.02247 9.78551 6.07543L10.713 7.00001C10.9568 7.24381 11.1502 7.53323 11.2821 7.85176C11.4141 8.17029 11.482 8.5117 11.482 8.85647C11.482 9.20125 11.4141 9.54265 11.2821 9.86118C11.1502 10.1797 10.9568 10.4691 10.713 10.7129C10.4692 10.9567 10.1798 11.1501 9.86126 11.2821C9.54273 11.414 9.20133 11.4819 8.85655 11.4819C8.51178 11.4819 8.17037 11.414 7.85184 11.2821C7.53331 11.1501 7.24389 10.9567 7.00009 10.7129L6.07259 9.78543C6.0203 9.72437 5.95595 9.67477 5.88358 9.63976C5.8112 9.60474 5.73238 9.58507 5.65204 9.58196C5.5717 9.57886 5.49159 9.5924 5.41674 9.62172C5.34188 9.65105 5.2739 9.69553 5.21705 9.75238C5.1602 9.80923 5.11571 9.87722 5.08639 9.95208C5.05706 10.0269 5.04352 10.107 5.04663 10.1874C5.04973 10.2677 5.06941 10.3465 5.10442 10.4189C5.13943 10.4913 5.18903 10.5556 5.25009 10.6079L6.17759 11.5383C6.53526 11.8972 6.96189 12.18 7.43176 12.3696C8.34774 12.7389 9.3712 12.7389 10.2872 12.3696C10.7565 12.1789 11.1828 11.8961 11.541 11.538C11.8991 11.1798 12.1819 10.7535 12.3726 10.2842C12.7419 9.3682 12.7419 8.34474 12.3726 7.42876H12.3697Z"
                                                        fill="currentColor" />
                                                    <path
                                                        d="M8.85566 9.43832C8.96801 9.43574 9.07723 9.40076 9.17017 9.33759C9.26312 9.27442 9.33584 9.18574 9.37958 9.08223C9.42333 8.97871 9.43625 8.86476 9.41678 8.75408C9.39731 8.6434 9.34628 8.5407 9.26983 8.45832L5.55691 4.73082C5.50272 4.67663 5.43837 4.63364 5.36756 4.6043C5.29675 4.57497 5.22085 4.55988 5.1442 4.55988C5.06756 4.55988 4.99166 4.57497 4.92085 4.6043C4.85004 4.63364 4.78569 4.67663 4.7315 4.73082C4.6773 4.78502 4.63431 4.84936 4.60498 4.92018C4.57564 4.99099 4.56055 5.06689 4.56055 5.14353C4.56055 5.22018 4.57564 5.29608 4.60498 5.36689C4.63431 5.4377 4.6773 5.50204 4.7315 5.55624L8.459 9.26916C8.56476 9.37414 8.70669 9.43467 8.85566 9.43832Z"
                                                        fill="currentColor" />
                                                </svg>
                                                {{ t('inspiration.copyLink') }}
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 音乐详情弹窗 -->
        <tool-ugc-detail-item-info v-if="showMusicMask" @closeMask="
            () => {
                showMusicMask = false
            }
        " :showDataItemInfo="currentMusicDetailItem" @changeLikeStateForItem="changeMusicLikeState"
            :hidden_like="true"></tool-ugc-detail-item-info>

        <el-drawer v-model="filterModal" direction="btt" :show-close="false" :with-header="false" :size="'auto'"
            modal-class="pop-filter">
            <div class="filter-sheet">
                <div class="filter-sheet__header">
                    <span class="filter-sheet__title">
                        {{ t('myCreations.filterTitle') }}
                    </span>
                    <button class="filter-sheet__close" @click="closeFilterModal" aria-label="close">
                        ✕
                    </button>
                </div>

                <div class="filter-sheet__section">
                    <div class="filter-sheet__label">
                        {{ t('myCreations.filterByType') }}
                    </div>
                    <div class="filter-sheet__options">
                        <button v-for="item in generate_type_list" :key="item.value" class="filter-chip" :class="{
                            'filter-chip--active':
                                filterDraft.category === item.value,
                        }" @click="filterDraft.category = item.value">
                            {{ item.label }}
                        </button>
                    </div>
                </div>

                <div class="filter-sheet__section">
                    <div class="filter-sheet__label">
                        {{ t('myCreations.filterByTime') }}
                    </div>
                    <div class="filter-sheet__options">
                        <button v-for="item in timeEnums" :key="item.value" class="filter-chip" :class="{
                            'filter-chip--active':
                                filterDraft.time === item.value,
                        }" @click="filterDraft.time = item.value">
                            {{ item.label }}
                        </button>
                    </div>
                </div>

                <button class="filter-sheet__confirm" @click="applyFilter">
                    {{ t('batchTools.confirm') }}
                </button>
            </div>
        </el-drawer>
        <ui-language-modal></ui-language-modal>
    </div>
</template>

<script setup lang="ts">
import {
    ref,
    reactive,
    computed,
    onMounted,
    watch,
    onBeforeUnmount,
    nextTick,
} from 'vue'
import { useHead, useRequestURL } from '#imports'
import { useI18n } from '~/composables/useI18n'
import { useMusicPlayerStore } from '~/stores/musicPlayer'
import { analyticsEvent } from '~/utils/log-event-func'
import {
    getCreationHistoryApi,
    type CreationRecord,
    getCreationShareLinkApi,
} from '~/api/creations'
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'
// Import Swiper core and required modules
import { Navigation, A11y } from 'swiper/modules'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import { useToolsHooks } from '~/utils/useHooks'
import dayjs from 'dayjs'
import {
    flattenModelResults,
    noticeMessagePopup,
    getResourceThumbnail,
} from '~/utils/common'
import { useMultilingualSeo } from '~/composables/useMultilingualSeo'
import ImageLazy from '~/components/ui/ImageLoadLoading.vue'
import { useUserStore } from '~/stores/user'
import { emitter, emitOpenGoodsModal, showLoginModal } from '~/utils/emitter'
import { useAppStore } from '@/stores/app'
import { LOGIN_ENTRY_ENABLED } from '~/utils/feature-flags'

const userStore = useUserStore()
const appStore = useAppStore()
const vip_level = ref('')
const next_billing_date = ref('')
const sub_info = ref<any>(null)
const user_info = computed(() => userStore.userInfo)
const isLoggedIn = computed(() => userStore.isLoggedIn)
const accountSummary = computed(() => userStore.accountSummary)
const isVip = computed(() => {
    sub_info.value = accountSummary.value?.sub_info

    return accountSummary.value?.sub_info?.subscription_type
})

useMultilingualSeo({ pageType: 'myCreations' })

// BreadcrumbList 结构化数据
const requestUrlHref = useRequestURL().href
const { t: tSeo, locale } = useI18n()

useHead({
    script: [
        {
            type: 'application/ld+json',
            innerHTML: computed(() =>
                JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                        {
                            '@type': 'ListItem',
                            position: 1,
                            name: '微鲤AI',
                            item: 'https://www.weryai.com.cn',
                        },
                        {
                            '@type': 'ListItem',
                            position: 2,
                            name: tSeo('myCreations.pageTitle'),
                            item: requestUrlHref,
                        },
                    ],
                })
            ),
        },
    ],
})
const { videosRouterEnums, imagesRouterEnums, handleMenuLinkClick } =
    useToolsHooks()

definePageMeta({
    layout: 'default',
})

const { t } = useI18n()
const router = useRouter()
const musicPlayer = useMusicPlayerStore()

// Types
interface ContentItem {
    id: number
    type: 'image' | 'video'
    title: string
    thumbnail: string
    results: string[] // 添加 results 字段用于存储所有图片/视频
    createdAt: Date
    isFavorite: boolean
    prompts?: string[] // 添加 prompts 字段用于判断是否显示信息
    result_type: 'IMAGE' | 'VIDEO'
    batch_items?: {
        results: string[]
        model: string
    }[]
    result_list?: string[]
}

// Reactive data
const activeFilter = ref('all')
const previewItem = ref<any>(null)
const downloading = ref(false)
const contentList = ref<CreationRecord[]>([])
const loading = ref(false)
const initialized = ref(false)
const loadingMore = ref(false)
const hasMore = ref(true)
const isClient = ref(false)
const total = ref(0)
const swiperRef = ref(null)
const infiniteObserver = ref<IntersectionObserver | null>(null)
const sentinelRef = ref<HTMLElement | null>(null)

// 瀑布流列数逻辑
const columnCount = ref<number>(2)
const updateColumnCount = () => {
    if (!import.meta.client) return
    const width = window.innerWidth
    if (width >= 1536) columnCount.value = 7
    else if (width >= 1280) columnCount.value = 6
    else if (width >= 1024) columnCount.value = 5
    else if (width >= 768) columnCount.value = 4
    else if (width >= 640) columnCount.value = 3
    else columnCount.value = 2
}

// 核心：稳定分配算法，确保加载时图片不会跳列
const columnList = computed(() => {
    const columns: any[][] = Array.from({ length: columnCount.value }, () => [])
    history_list.value.forEach((item, index: number) => {
        columns[index % columnCount.value]?.push(item)
    })
    return columns
})

// ===== 图片渐进加载（thumbnail -> origin，保证不闪）=====
const creationImageLoadedState = reactive<Record<string, boolean>>({})
const creationThumbErrorState = reactive<Record<string, boolean>>({})
const creationOriginErrorState = reactive<Record<string, boolean>>({})

const getCreationImageUrl = (item: any) => {
    return item?.results?.[0] || item?.batch_items?.[0]?.results?.[0] || ''
}

const getCreationImageKey = (item: any) => {
    const url = getCreationImageUrl(item)
    return `${String(item?.id || '')}|${String(url)}`
}

const isCreationImageLoaded = (item: any) => {
    const key = getCreationImageKey(item)
    return key ? !!creationImageLoadedState[key] : false
}

const isCreationThumbError = (item: any) => {
    const key = getCreationImageKey(item)
    return key ? !!creationThumbErrorState[key] : false
}

const isCreationOriginError = (item: any) => {
    const key = getCreationImageKey(item)
    return key ? !!creationOriginErrorState[key] : false
}

const markCreationThumbError = (item: any) => {
    const key = getCreationImageKey(item)
    if (!key) return
    creationThumbErrorState[key] = true
}

const markCreationOriginError = (item: any) => {
    const key = getCreationImageKey(item)
    if (!key) return
    creationOriginErrorState[key] = true
    creationImageLoadedState[key] = false
}

const markCreationImageLoaded = (item: any) => {
    const key = getCreationImageKey(item)
    if (!key) return
    creationImageLoadedState[key] = true
    creationOriginErrorState[key] = false
}

/**
 * 核心修复点：
 * SSR/水合时，图片可能在事件监听挂上前就已经 load 完成（尤其命中缓存），
 * 导致模板里的 @load 不触发，状态永远不更新。
 * 因此这里用 new Image() 主动预加载原图，确保一定能触发回调/complete 检测。
 */
const preloadCreationOrigin = (item: any) => {
    if (!import.meta.client) return
    if (item?.result_type !== 'IMAGE') return

    const key = getCreationImageKey(item)
    const src = getCreationImageUrl(item)
    if (!key || !src) return
    if (creationImageLoadedState[key]) return

    const img = new Image()
    img.src = src

    if (img.complete && img.naturalWidth > 0) {
        creationImageLoadedState[key] = true
        creationOriginErrorState[key] = false
        return
    }

    img.onload = () => {
        creationImageLoadedState[key] = true
        creationOriginErrorState[key] = false
    }
    img.onerror = () => {
        creationImageLoadedState[key] = false
        creationOriginErrorState[key] = true
    }
}

watch(
    () => contentList.value.map(getCreationImageKey).join('|'),
    () => {
        // 只保留当前列表的状态，避免无限增长
        const activeKeys = new Set(contentList.value.map(getCreationImageKey))
        Object.keys(creationImageLoadedState).forEach(k => {
            if (!activeKeys.has(k)) delete creationImageLoadedState[k]
        })
        Object.keys(creationThumbErrorState).forEach(k => {
            if (!activeKeys.has(k)) delete creationThumbErrorState[k]
        })
        Object.keys(creationOriginErrorState).forEach(k => {
            if (!activeKeys.has(k)) delete creationOriginErrorState[k]
        })

        // 预加载当前可见列表里的图片原图（避免错过 @load）
        contentList.value.forEach(preloadCreationOrigin)
    },
    { immediate: true }
)

onMounted(() => {
    contentList.value.forEach(preloadCreationOrigin)
})

// 音乐详情弹窗
const showMusicMask = ref(false)
const currentMusicDetailItem = ref<any>(null)

// Swiper modules
const modules = [Navigation, A11y]

// Swiper 相关方法
const onSwiper = (swiper: any) => {
    swiperRef.value = swiper
}

const onSlideChange = (swiper: any) => {
    // 切换 slide 时暂停所有视频
    const videos = swiper.el.querySelectorAll('video')
    videos.forEach((video: HTMLVideoElement) => {
        video.pause()
    })
}

// 判断是否有多个图片/视频
const hasMultipleResults = computed(() => {
    if (!previewItem.value) return false

    const resultsCount = previewItem.value?.results?.length || 0
    const resultListCount = previewItem.value?.result_list?.length || 0

    // 使用较大的那个数组长度来判断是否有多个结果
    return Math.max(resultsCount, resultListCount) > 1
})

// Content filters
const contentFilters = computed(() => [
    { key: 'all', label: t('myCreations.all') },
    { key: 'videos', label: t('myCreations.videos') },
    { key: 'images', label: t('myCreations.images') },
])

// 将 API 数据转换为组件需要的格式
const transformedContent = computed(() => {
    return contentList.value.map(item => {
        // 判断类型：所有包含IMAGE的类型都视为image，包含VIDEO的视为video
        const resultType = item.result_type.toUpperCase()
        let type: 'image' | 'video' = 'image'

        if (resultType.includes('VIDEO')) {
            type = 'video'
        } else if (
            resultType.includes('IMAGE') ||
            resultType.includes('TEXT')
        ) {
            type = 'image'
        }

        return {
            id: item.id,
            type,
            title: (item.prompts && item.prompts[0]) || '',
            thumbnail: (item.results && item.results[0]) || '',
            results: item.results || [], // 保存所有图片/视频
            createdAt: new Date(item.created_at), // API已经返回毫秒级时间戳
            isFavorite: false,
            prompts: item.prompts || [], // 保留 prompts 用于判断
        }
    })
})

// Computed properties
const hasContent = computed(() => {
    return history_list.value.length > 0
})

const openPreview = (item: any) => {
    // 音乐类型使用专门的弹窗
    if (
        item.result_type === 'AUDIO' ||
        item?.type === 'MUSIC_CREATION_GENERATION'
    ) {
        openMusicMask(item)
        return
    }
    previewItem.value = item
}

const closePreview = () => {
    previewItem.value = null
}

// 打开音乐详情弹窗
const openMusicMask = (item: any) => {
    showMusicMask.value = true
    // 转换数据格式以适配 UgcDetailItemInfo 组件
    // my-creations 页面的数据结构与 AIMusic 不同，需要做适配
    //
    // 接口字段映射：
    // - results[0]: 封面图
    // - results[1]: 音频文件
    // - request_params.ref_music: 参考音频 URL
    // - request_params.audio_name: 参考音频名称
    // - request_params.styles: 风格标签（对象形式 {ROCK: "摇滚"}）
    // - request_params.prompt: 提示词
    // - request_params.lyrics: 用户输入的歌词
    // - request_params.vocal_gender: 音色（m/f）
    // - music.music_title: 生成的音乐标题
    // - music.generated_lyrics: 生成的歌词
    currentMusicDetailItem.value = {
        ...item,
        ins_id: item.id,
        output: item.results?.[0] || '', // 封面图
        output_audio: item.results?.[1] || '', // 音频文件
        music: {
            music_title:
                item.music?.music_title || item.request_params?.prompt || '',
            generated_lyrics: item.music?.generated_lyrics || '',
            music_style:
                item.music?.music_style ||
                (item.request_params?.styles
                    ? Object.values(item.request_params.styles).join(', ')
                    : ''),
        },
        param: {
            type: item.request_params?.type || 'VOCAL_SONG',
            styles: item.request_params?.styles
                ? Object.keys(item.request_params.styles)
                : [],
            prompt: item.request_params?.prompt || '',
            lyrics: item.request_params?.lyrics || '', // 用户输入的歌词
            vocal_gender: item.request_params?.vocal_gender || '', // 音色
            // 参考音频：转换为 audio_urls 数组格式（UgcDetailItemInfo 从 audio_urls[0] 取值）
            audio_urls: item.request_params?.ref_music
                ? [item.request_params.ref_music]
                : [],
            // 参考音频名称
            name: item.request_params?.audio_name || '',
        },
    }
}

// 监听音乐弹窗状态，控制 body 滚动
watch(
    showMusicMask,
    newVal => {
        if (typeof window === 'undefined' || typeof document === 'undefined')
            return

        if (newVal) {
            const scrollbarWidth =
                window.innerWidth - document.documentElement.clientWidth
            document.body.style.overflow = 'hidden'
            document.body.style.paddingRight = scrollbarWidth + 'px'
        } else {
            document.body.style.overflow = ''
            document.body.style.paddingRight = ''
        }
    },
    { immediate: true }
)

// 音乐弹窗点赞事件处理（当前页面不需要实现，占位函数）
const changeMusicLikeState = async (event: MouseEvent, item: any) => {
    // 这里是我的创作页面，点赞逻辑可以后续实现
    console.log('Like music:', item)
}

// 导航到创建页面
const goToCreate = () => {
    handleMenuLinkClick('/text-to-image')
}

// For demo purposes, you can toggle content visibility
// Uncomment the line below to show empty state
// mockContent.value = []

// 格式化视频时长
const formatDuration = (raw?: number | string) => {
    if (raw === undefined || raw === null || raw === '') return ''
    const n = typeof raw === 'string' ? parseFloat(raw) : raw
    if (Number.isNaN(n)) return ''
    if (n >= 60) {
        const m = Math.floor(n / 60)
        const s = Math.round(n % 60)
        return s ? `${m}m${s}s` : `${m}m`
    }
    return `${Math.round(n)}s`
}

// 获取视频时长
const getVideoDuration = (url: string): Promise<number> => {
    return new Promise(resolve => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
            resolve(video.duration)
            video.src = ''
        }
        video.onerror = () => {
            resolve(0)
        }
        video.src = url
    })
}

// 批量获取视频时长（并行）
const fetchVideoDurations = async (items: any[]) => {
    const videoItems = items.filter(
        item => item.result_type === 'VIDEO' && !item.duration
    )

    await Promise.all(
        videoItems.map(async item => {
            const url =
                item?.results?.[0] || item?.batch_items?.[0]?.results?.[0]
            if (url) {
                const dur = await getVideoDuration(url)
                const target = history_list.value.find(
                    (i: any) => i.id === item.id
                )
                if (target) {
                    target.duration = dur
                }
            }
        })
    )
}

const downloadItem = async (item: any) => {
    console.log('下载---', item)

    // 判断是否为音乐类型
    const isMusicType =
        item.result_type === 'AUDIO' ||
        item?.type === 'MUSIC_CREATION_GENERATION'

    if (item.results && item.results.length > 0) {
        // 音乐类型下载 results[1]（音频文件），其他类型下载 results[0]
        const downloadUrl = isMusicType ? item.results?.[1] : item.results?.[0]
        if (downloadUrl) {
            await downloadCurrentItem(
                downloadUrl,
                isMusicType ? 'AUDIO' : item.result_type
            )
        }
    } else if (item?.batch_items) {
        await downloadCurrentItem(
            item?.batch_items?.[0]?.results?.[0],
            item.result_type
        )
    }
}

const downloadCurrentItem = async (
    fileUrl: string,
    resultType?: 'TEXT' | 'IMAGE' | 'VIDEO' | 'AUDIO'
) => {
    if (!fileUrl || downloading.value) return

    try {
        downloading.value = true

        // 优先使用传入的 resultType，否则从 previewItem 获取
        const typeToUse = resultType || previewItem.value?.result_type
        console.log('download type:', typeToUse)

        // 根据类型确定文件扩展名和前缀
        let extension = 'png'
        let prefix = 'image'
        if (typeToUse === 'VIDEO') {
            extension = 'mp4'
            prefix = 'video'
        } else if (typeToUse === 'AUDIO') {
            extension = 'mp3'
            prefix = 'music'
        }

        // 创建一个临时的 a 标签来触发下载
        const link = document.createElement('a')
        link.download = `${prefix}_${Date.now()}.${extension}`
        link.target = '_blank'

        // 对于跨域资源，尝试使用 fetch 下载
        try {
            const response = await fetch(fileUrl)
            const blob = await response.blob()
            const blobUrl = window.URL.createObjectURL(blob)

            link.href = blobUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            // 清理 blob URL
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100)
        } catch (error) {
            // 如果 fetch 失败（可能是跨域问题），直接打开链接
            console.warn('Fetch下载失败，尝试直接下载:', error)
            link.href = fileUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    } catch (error) {
        console.error('下载失败:', error)
    } finally {
        downloading.value = false
    }
}

// 获取创作历史数据
const timeEnums = computed(() => {
    return [
        {
            label: t('batchTools.all'),
            value: 'all',
        },
        {
            label: t('batchTools.threeDays'),
            value: 'threeDays',
        },
        {
            label: t('batchTools.onWeek'),
            value: 'onWeek',
        },
        {
            label: t('batchTools.oneMonth'),
            value: 'oneMonth',
        },
    ]
})

const generate_type_list = computed(() => {
    return [
        {
            label: t('batchTools.all'),
            value: 'all',
        },
        {
            label: t('batchTools.IMAGE'),
            value: 'IMAGE',
        },
        {
            label: t('batchTools.VIDEO'),
            value: 'VIDEO',
        },
        {
            label: t('batchTools.AUDIO'),
            value: 'MUSIC',
        },
        // {
        //     label: t('batchTools.TOOL'),
        //     value: 'TOOL',
        // },
    ]
})
const query = ref({
    time: 'all',
    category: 'all',
    startTime: '',
    endTime: '',
    page: 1,
    size: 24,
})

// 切换生成类型
const handleChangeGenerateType = (value: string) => {
    query.value.category = value
    // 重置分页并重新加载
    query.value.page = 1
    history_list.value = []
    hasMore.value = true
    handleGetCreationHistory()
}

const handleChangeTime = (value: string) => {
    query.value.time = value
    // 重置分页并重新加载
    query.value.page = 1
    history_list.value = []
    hasMore.value = true
    handleGetCreationHistory()
}

/**
 * 根据时间过滤器value计算起止时间戳
 * @param timeValue 时间过滤器的value ('all' | 'threeDays' | 'onWeek' | 'oneMonth')
 * @returns { startTime: number, endTime: number } | null
 */
const getTimeRange = (
    timeValue: string
): { startTime: number; endTime: number } | null => {
    if (timeValue === 'all') {
        return null
    }

    const now = dayjs()
    let startTime: dayjs.Dayjs
    const endTime = now.endOf('day') // 结束时间：今天的23:59:59

    switch (timeValue) {
        case 'threeDays':
            // 最近三天：从3天前的00:00:00到现在
            startTime = now.subtract(2, 'day').startOf('day') // 减去2天，因为包含今天
            break
        case 'onWeek':
            // 最近一周：从7天前的00:00:00到现在
            startTime = now.subtract(6, 'day').startOf('day') // 减去6天，因为包含今天
            break
        case 'oneMonth':
            // 最近一个月：从30天前的00:00:00到现在
            startTime = now.subtract(29, 'day').startOf('day') // 减去29天，因为包含今天
            break
        default:
            return null
    }

    return {
        startTime: startTime.valueOf(), // 转换为时间戳（毫秒）
        endTime: endTime.valueOf(), // 转换为时间戳（毫秒）
    }
}

const history_list = ref<any[]>([])

const normalizeItems = (items: any[]) => {
    return items.map(item => {
        const next = { ...item, duration: 0 }
        next.result_list = next.batch_items?.length
            ? flattenModelResults(next.batch_items).map((it: any) => it.url)
            : []

        // 如果 result_type 为空，从 URL 后缀推断类型
        if (!next.result_type) {
            const firstUrl =
                next?.results?.[0] ||
                next?.batch_items?.[0]?.results?.[0] ||
                next?.result_list?.[0]
            if (firstUrl) {
                const lowerUrl = firstUrl.toLowerCase()
                if (
                    lowerUrl.includes('.mp4') ||
                    lowerUrl.includes('.webm') ||
                    lowerUrl.includes('.mov') ||
                    lowerUrl.includes('/video/')
                ) {
                    next.result_type = 'VIDEO'
                } else if (
                    lowerUrl.includes('.jpg') ||
                    lowerUrl.includes('.jpeg') ||
                    lowerUrl.includes('.png') ||
                    lowerUrl.includes('.webp') ||
                    lowerUrl.includes('.gif') ||
                    lowerUrl.includes('/image/')
                ) {
                    next.result_type = 'IMAGE'
                }
            }
        }
        return next
    })
}

const handleGetCreationHistory = async (isLoadMore = false) => {
    if (loading.value || loadingMore.value) return

    const { category, time } = query.value
    const timeRange = getTimeRange(time)
    const nextPage = isLoadMore ? query.value.page + 1 : 1

    if (!isLoadMore) {
        history_list.value = []
        hasMore.value = true
    }

    const params: any = {
        page: nextPage,
        size: query.value.size,
        category:
            category === 'all' ? '' : (category as 'IMAGE' | 'VIDEO' | 'TOOL'),
        sourceType: 'MY_CREATIONS',
    }

    if (timeRange) {
        params.startTime = timeRange.startTime
        params.endTime = timeRange.endTime
    }

    if (isLoadMore) {
        loadingMore.value = true
    } else {
        loading.value = true
    }

    try {
        // 跳过 productId，查看所有项目的创作记录
        const res = await getCreationHistoryApi(params, { skipProductId: true })
        if (res.status === 200) {
            const incoming = normalizeItems(res.data.content || [])
            history_list.value = isLoadMore
                ? [...history_list.value, ...incoming]
                : incoming

            history_list.value = history_list.value.filter((item: any) => {
                return (
                    getCreationImageUrl(item) &&
                    ['SUCCESS', 'PARTIAL_SUCCESS', 'GENERATING'].includes(
                        item.status
                    )
                )
            })

            total.value = res.data.total || 0
            const totalPages = res.data.total_page || 1
            query.value.page = nextPage
            hasMore.value =
                nextPage < totalPages && history_list.value.length < total.value

            // 异步获取视频时长
            fetchVideoDurations(incoming)
        }
    } catch (error) {
        console.error('Failed to fetch creations:', error)
    } finally {
        if (isLoadMore) {
            loadingMore.value = false
        } else {
            loading.value = false
            initialized.value = true
            // 首次加载或切换筛选后，需要重新初始化 Observer
            nextTick(() => {
                initInfiniteObserver()
            })
        }
    }
}

const initInfiniteObserver = () => {
    if (typeof IntersectionObserver === 'undefined') return
    if (infiniteObserver.value) {
        infiniteObserver.value.disconnect()
    }
    if (!sentinelRef.value) return

    infiniteObserver.value = new IntersectionObserver(entries => {
        const entry = entries[0]
        if (
            entry?.isIntersecting &&
            hasMore.value &&
            !loading.value &&
            !loadingMore.value
        ) {
            handleGetCreationHistory(true)
        }
    })

    infiniteObserver.value.observe(sentinelRef.value)
}

const copy_loading = ref(false)
// 复制链接
const copyLink = async (item: any) => {
    if (!isClient) return
    if (copy_loading.value) return
    copy_loading.value = true
    try {
        const { id, results, batch_items } = item
        const resource_url = results?.[0] || batch_items?.[0]?.results?.[0]
        const res = await getCreationShareLinkApi({
            history_id: id,
            resource_url,
        })
        if (res.status === 200) {
            const origin = window.location.origin // "https://weryai.com"
            const path = `${origin}/creation/${res?.data || ''}`
            copyText(path)
        }
    } catch (e) {
        console.error('copy link failed:', e)
    } finally {
        copy_loading.value = false
    }
}
const copyText = async (text: string) => {
    if (!isClient || !text) return

    try {
        await navigator.clipboard.writeText(text)
        noticeMessagePopup(
            t('inspiration.copySuccess'),
            t('common.tip'),
            'success',
            3000
        )
        // 成功提示
    } catch (err) {
        console.error('复制失败:', err)
        noticeMessagePopup(
            t('inspiration.copyFailed'),
            t('common.tip'),
            'error',
            3000
        )
    }
}

const runtimeConfig = useRuntimeConfig()

const chooseTypeEnums = computed(() => {

    const list = [
        {
            name: t('menus.billing'),
            type: 'billing',
            icon: 'i-billing-icon',
        },
        // {
        //     name: t('menus.language'),
        //     type: 'language',
        //     icon: 'i-language-icon',
        // },

    ]
    return !isLoggedIn.value ? list.slice(1, 2) : list
})

const handleChooseType = (type: string) => {
    switch (type) {
        case 'billing':
            navigateTo('/billing')
            break
        case 'language':
            //    打开切换语言弹窗
            emitter.emit('open-language-modal')
            break
        case 'logout':
            userStore.logout()
            appStore.clearRecentCreatedOrder()
            if (isClient.value) {
                window.location.href = location.origin
            } else {
                navigateTo('/')
            }
            break
    }
}

// 格式化金币数量（超过1万用w表示）
const formattedCredits = computed(() => {
    const val = userStore.balance
    if (val >= 10000) {
        return (val / 10000).toFixed(1) + 'w'
    }
    return val.toString()
})

// 监听筛选器变化（预留）
watch(activeFilter, () => {
    query.value.page = 1
    history_list.value = []
    hasMore.value = true
    handleGetCreationHistory()
})

// 筛选器弹窗
const filterModal = ref(false)
const filterDraft = reactive({
    time: query.value.time,
    category: query.value.category,
})
const handleFilter = () => {
    filterDraft.time = query.value.time
    filterDraft.category = query.value.category
    filterModal.value = true
}
const closeFilterModal = () => {
    filterModal.value = false
}
const applyFilter = () => {
    const nextTime = filterDraft.time
    const nextCategory = filterDraft.category
    filterModal.value = false

    if (
        nextTime === query.value.time &&
        nextCategory === query.value.category
    ) {
        return
    }

    query.value.time = nextTime
    query.value.category = nextCategory
    query.value.page = 1
    history_list.value = []
    hasMore.value = true
    handleGetCreationHistory()
}

// 组件挂载时加载数据并初始化瀑布流监听
onMounted(async () => {
    analyticsEvent('page_view_creations')

    // 注册 dot-spinner 组件
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            isClient.value = true
        }
    }

    await handleGetCreationHistory()
    updateColumnCount()
    window.addEventListener('resize', updateColumnCount)
    await nextTick()
    initInfiniteObserver()
})

onBeforeUnmount(() => {
    // 停止音乐播放
    musicPlayer.stop()
    window.removeEventListener('resize', updateColumnCount)
    if (infiniteObserver.value) {
        infiniteObserver.value.disconnect()
    }
})
</script>

<style scoped lang="less">
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.my-creations-page {
    min-height: calc(100vh - 80px);
    width: 100%;
    padding: 0;
    padding-bottom: 30px;
}

.content-container {
    max-width: none;
    margin: 0;
}

.waterfall-column {
    min-width: 0;
}

.filters-section {
    margin-bottom: 20px;
    margin-left: 10px;
}

.hover\:bg-gray-750:hover {
    background-color: #374151;
}

.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.tool-box {
    position: absolute;
    bottom: 58px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 360px;
    width: calc(100% - 32px);
    min-width: fit-content;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.download-button,
.pop-copy-link {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ffffff4d;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.2);
    color: white;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 20;
    white-space: nowrap;

    &:hover:not(:disabled) {
        background: rgba(0, 0, 0, 0.75);
        transform: scale(1.1);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    svg {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
    }

    span {
        line-height: 1;
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.preview-modal-content {
    width: auto;
    min-width: 300px;
    max-width: 90vw;
}

.preview-content {
    width: 100%;
}

.preview-single,
.preview-swiper {
    width: 100%;
    max-width: 85vw;
    margin: 0 auto;
}

.preview-swiper-container {
    width: 100% !important;
    height: auto !important;
}

:deep(.el-drawer) {
    padding: 0;
    background: #1c1c20 !important;
    border-radius: 16px 16px 0 0;
}

.filter-sheet {
    color: #ffffff;
}

.filter-sheet__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
}

.filter-sheet__title {
    font-size: 16px;
    font-weight: 600;
}

.filter-sheet__close {
    width: 28px;
    height: 28px;
    color: #a1a1aa;
    font-size: 18px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.filter-sheet__section {
    margin-bottom: 18px;
}

.filter-sheet__label {
    color: #71717a;
    font-size: 11px;
    margin-bottom: 10px;
}

.filter-sheet__options {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.filter-chip {
    padding: 10px 14px;
    border-radius: 11px;
    color: #d1d5db;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid transparent;
    transition: all 0.3s ease;
}

.filter-chip--active {
    background: #27272a;
    border-color: #22c55e;
    color: #fff;
}

.filter-sheet__confirm {
    width: 100%;
    padding: 12px 16px;
    color: #000000;
    font-weight: 600;
    font-size: 13px;
    margin-top: 44px;
    border-radius: 14px;
    background: #99f768;
    box-shadow:
        0 10px 15px -3px rgba(20, 83, 45, 0.2),
        0 4px 6px -4px rgba(20, 83, 45, 0.2);
}

:deep(.swiper-button-prev) {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url('~/assets/images/common/right-arrow.svg');
    background-size: 24px 24px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgb(0 0 0 / 0.4);
    rotate: 180deg;
    color: transparent;

    &::after {
        display: none !important;
        content: '' !important;
    }

    svg {
        display: none;
    }

    &:hover {
        background-color: rgb(0 0 0 / 0.6);
    }
}

:deep(.swiper-button-next) {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url('~/assets/images/common/right-arrow.svg');
    background-size: 24px 24px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgb(0 0 0 / 0.4);
    color: transparent;

    &::after {
        display: none !important;
        content: '' !important;
    }

    svg {
        display: none;
    }

    &:hover {
        background-color: rgb(0 0 0 / 0.6);
    }
}

:deep(.el-pager) {
    font-size: 14px;

    & li {
        color: rgba(255, 255, 255, 0.6);
    }

    & li.is-active {
        border-radius: 9px;
        color: var(--weryai-text-active);
        margin: 0 5px;
        width: 40px;
        height: 40px;
        border: 1px solid var(--weryai-text-active);
        cursor: pointer;
    }
}

:deep(.is-selected) {
    color: #fb923c;
}

:deep(.el-select__wrapper) {
    background: #2c2e36;
}

@media (max-width: 768px) {
    .filters-section {
        margin-left: 0;
    }

    .content-grid {
        margin-left: 0;
    }

    .preview-modal-content {
        max-width: 95vw;
        min-width: 250px;
    }

    .preview-single,
    .preview-swiper {
        max-width: 90vw;
    }

    :deep(.swiper-button-prev),
    :deep(.swiper-button-next) {
        width: 36px;
        height: 36px;
        background-size: 20px 20px;
    }
}


.music-card-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.music-card-bg {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    transform: scale(1.1);
    z-index: 0;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.3);
    }
}

// 左上角类型标签
.music-type-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    height: 22px;
    padding: 0 8px;

    span {
        font-size: 9px;
        color: #fff;
        line-height: 1;
    }
}

.vinyl-record {
    width: 80%;
    aspect-ratio: 1;
    position: relative;
    z-index: 1;
}

.vinyl-outer {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background-color: rgba(8, 8, 8, 0.7);
}

.vinyl-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 55%;
    height: 55%;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.vinyl-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1.2);
}

.vip-card {
    border-radius: 14px;
    border: 1px solid #2b3d2e;
    background: linear-gradient(90deg, #1b2a1d 0%, #121a13 100%);
    box-shadow:
        0 10px 15px -3px rgba(20, 83, 45, 0.1),
        0 4px 6px -4px rgba(20, 83, 45, 0.1);
}

.pay-money {
    background: linear-gradient(94deg, #feffb5 -3.87%, #99f768 99.21%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.skeleton-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.i-billing-icon {
    mask: url('~/assets/images/menu/billing.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/billing.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-user-icon {
    mask: url('~/assets/images/menu/user.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/user.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-language-icon {
    mask: url('~/assets/images/menu/lang.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/lang.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-logout-icon {
    mask: url('~/assets/images/menu/logout.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/logout.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

:deep(.el-dropdown) {
    &:focus-visible {
        outline: none !important;
    }
}

.group {
    &:focus-visible {
        outline: none !important;
    }
}

:deep(.el-dropdown-menu__item) {
    position: relative;
    z-index: 10;
    padding: 6px 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;

    &:last-child {
        margin-bottom: 0;
    }
}

.my-setting {
    background-color: #1a1a1c;
    border-radius: 10px;
    padding: 5px;
    position: relative;
    z-index: 2;
}

.generate-popper {
    border-radius: 10px !important;
    border: none !important;
}

.my-setting::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 1px;
    background: linear-gradient(180deg,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 100%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: 1;
}

:deep(.el-dropdown__popper.el-popper) {
    border: none;
}
</style>

<style lang="less">
.generate-popper.el-dropdown__popper.el-popper,
.el-dropdown__popper.el-popper {
    border: none !important;
}

.nick-name {
    color: #fff;
    font-family: Inter;
    font-size: 21px;
    font-style: italic;
    line-height: 28px;
    /* 133.333% */
    letter-spacing: -0.525px;
    min-width: 200px;
}

.credits-card {
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(24, 24, 27, 0.4);
    backdrop-filter: blur(6px);
}

.pro-text {
    color: #5cfd81;
    font-family: Inter;
    font-size: 13px;
    font-style: italic;
    font-weight: 700;
    line-height: 17.5px;
    /* 142.276% */
    letter-spacing: 0.613px;
}
</style>
